<template>
    <div id="app" :class="{light: (this.backgroundColor === 'light')}">
        <header class="header">
            <transition appear
                v-on:before-enter="beforeEnterLogo"
                v-on:enter="enterLogo">
                <div class="header__logo-container">
                    <div class="header__logo-image-container">
                        <img class="header__logo" :class="{active: (this.logoColor === 'light')}" alt="Hunter PR Logo" src="@/assets/imgs/logo-hunter-white.png" />
                        <img class="header__logo" :class="{active: (this.logoColor === 'dark')}" alt="Hunter PR Logo" src="@/assets/imgs/logo-hunter-blue.png" />
                    </div>

                    <div class="header__logo-sub-title-container">
                        <span class="header__logo-sub-title"></span>
                    </div>
                </div>
            </transition>
        </header>

        <div class="header-nav-button-container">
            <button class="header-nav-button" v-on:click="navBtnClick" :class="{light: (this.menuColor === 'light')}"></button>
        </div>

        <div class="header-nav-overlay">
            <div class="header-nav-overlay__wrapper">
                <div class="header-nav-overlay__container">
                    <ul class="header-nav-overlay__list">
                        <li class="header-nav-overlay__list-item">
                            <router-link to="/" class="header-nav-overlay__link">
                                <img src="/assets/imgs/menu-hunter.png" class="header-nav-overlay__logo" alt="Hunter Public Relations">
                            </router-link>
                        </li>

                        <li class="header-nav-overlay__item">
                            <a class="header-nav-overlay__link" v-on:click="navLinkClick('/work/case-studies')">WORK</a>
                        </li>

                        <li class="header-nav-overlay__item">
                            <a class="header-nav-overlay__link" v-on:click="navLinkClick('/culture/explore')">CULTURE</a>
                        </li>

                        <li class="header-nav-overlay__item">
                            <a class="header-nav-overlay__link" v-on:click="navLinkClick('/expertise/explore')">EXPERTISE</a>
                        </li>

                        <li class="header-nav-overlay__item">
                            <a class="header-nav-overlay__link" v-on:click="navLinkClick('/news/newswire')">NEWS</a>
                        </li>

                        <li class="header-nav-overlay__item">
                            <a class="header-nav-overlay__link" v-on:click="navLinkClick('/contact')">CONTACT</a>
                        </li>
                    </ul>

                    <ul class="header-nav-overlay__social-list">
                        <li class="header-nav-overlay__social-item">
                            <a class="header-nav-overlay__social-link" href="https://www.facebook.com/HunterPR" target="_blank">
                                <img class="header-nav-overlay__social-image" src="/assets/imgs/menu-facebook.png" alt="Facebook">
                            </a>
                        </li>

                        <li class="header-nav-overlay__social-item">
                            <a class="header-nav-overlay__social-link" href="https://www.instagram.com/hunterprny/" target="_blank">
                                <img class="header-nav-overlay__social-image" src="/assets/imgs/menu-instagram.png" alt="Instagram">
                            </a>
                        </li>

                        <li class="header-nav-overlay__social-item">
                          <a class="header-nav-overlay__social-link" href="https://www.linkedin.com/company/hunterny" target="_blank">
                            <img class="header-nav-overlay__social-image" src="/assets/imgs/menu-linkedin.png" alt="Twitter">
                              </a>
                        </li>
                    </ul>

                    <div class="header-nav-overlay__copyright">&copy; Copyright HUNTER 2026. All Rights Reserved.</div>
                  <br/>&nbsp;<br/>
                    <div class="header-nav-overlay__privacy-policy">
                      <a class="header-nav-privacypolicy-overlay__link" v-on:click="navLinkClick('/privacypolicy')">Read HUNTER: Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>

        <transition
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:after-enter="afterEnter"
                v-on:before-leave="beforeLeave"
                v-on:leave="leave">
            <router-view :key="templateName"/>
        </transition>
    </div>
</template>


<style lang="less">
    @import "less/app.less";
    @import "less/breakpoints.less";

    .header {
        left: 50%;
        position: absolute;
        text-align: center;
        transform: translateX(-50%);
        top: 34px;
        z-index: 20;

        @media @breakpoint__mobile--large {
            top: 29px;
        }

        .header__logo-container {
            display: inline-flex;
            margin: 0 auto;
            z-index: 10;
        }

        .header__logo-image-container {
            display: inline-block;
            position: relative;
            vertical-align: top;
        }

        .header__logo {
            left: 0;
            opacity: 0;
            position: absolute;
            top: 0;
            transition: 0.5s opacity;

            &.active {
                position: relative;
                opacity: 1;
            }

            @media @breakpoint__mobile--large {
                margin-top: 0px;
                width: 90px;
            }

            @media @breakpoint__mobile--small {
                margin-top: 3px;
                width: 85px;
            }
        }

        .header__logo-sub-title-container {
            display: inline-block;
            overflow: hidden;
        }

        .header__logo-sub-title {
            color: #cccccd;
            font-size: 24px;
            line-height: 0.8;
            margin-left: 5px;
            text-transform: uppercase;

            @media @breakpoint__mobile--large {
                font-size: 18px;
                line-height: 0;
            }

            @media @breakpoint__mobile--small {
                font-size: 16px;
                line-height: 0;
            }
        }
    }

    .header-nav-button-container {
        position: absolute;
        margin: 0;
        padding: 0;
        width: 36px;
        height: 26px;
        top: 29px;
        right: 35px;
        text-align: center;
        border: 0;
        z-index: 212;
        cursor: pointer;

        @media @breakpoint__mobile--large {
            height: 22px;
            right: 20px;
            top: 26px;
            width: 30px;
        }
    }

    .header-nav-button {
        background: transparent;
        border: none;
        border-top: 5px solid #003A4A;
        border-bottom: 5px solid #003A4A;
        cursor: pointer;
        display: block;
        font-size: 0;
        height: 100%;
        position: relative;
        transition: all 0.4s;
        width: 100%;
        z-index: 50;

        &:before {
            background: #003A4A;
            content: '';
            display: block;
            height: 5px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.4s;
            width: 100%;

            @media @breakpoint__mobile--large{
                height: 4px;
            }
        }

        &:after {
            background: #003A4A;
            content: '';
            display: block;
            height: 5px;
            left: 50%;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.4s;
            width: 100%;

            @media @breakpoint__mobile--large{
                height: 4px;
            }
        }

        &:hover {
            color:#e40046;
            border-top: 5px solid #e40046;
            border-bottom: 5px solid #e40046;

            &:before,
            &:after {
                background: #e40046;
            }

            @media @breakpoint__tablet--large {
                color: #003A4A;
                border-top: 4px solid #003A4A;
                border-bottom: 4px solid #003A4A;

                &:before,
                &:after {
                    background: #003A4A;
                }
            }
        }

        &.light {
            color: #ffffff;
            border-top: 5px solid #ffffff;
            border-bottom: 5px solid #ffffff;

            &:before {
                background: #ffffff;
            }

            &:after {
                background: #ffffff;
            }

            @media @breakpoint__mobile--large {
                border-top: 4px solid #ffffff;
                border-bottom: 4px solid #ffffff;
            }

            &:hover {
                color:#e40046;

                @media @breakpoint__tablet--large {
                    color: #ffffff;
                    border-top: 4px solid #ffffff;
                    border-bottom: 4px solid #ffffff;

                    &:before,
                    &:after {
                        background: #ffffff;
                    }
                }
            }
        }

        &.active {
            border-color:transparent;

            &:before {
                background:#003a4a !important;
                transform: translate(-50%, -50%) rotate(45deg);
            }

            &:after {
                background:#003a4a !important;
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }

        &:focus {
            outline: none;
        }

        @media @breakpoint__mobile--large{
            border-top: 4px solid #003a4a;;
            border-bottom: 4px solid #003a4a;;
        }

        @media @breakpoint__tablet--large {
            &:hover {
                color:#003a4a;
            }
        }

        &.news-work {
            @media screen and (max-width: 930px) {
                color: #ffffff;
                border-top: 5px solid #ffffff;
                border-bottom: 5px solid #ffffff;

                &:before,
                &:after {
                    background: #ffffff;
                }

                &:hover {
                    color:#ffffff;
                    border-top: 5px solid #ffffff;
                    border-bottom: 5px solid #ffffff;

                    &:before,
                    &:after {
                        background: #ffffff;
                    }
                }
            }
        }
    }

    .header-nav-overlay {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
        padding: 0;
        width: 100%;
        height: 100vh;
        text-align: center;
        background: #fff;
        z-index: 111;
        overflow: hidden;
    }

    .header-nav-overlay__wrapper {
        width: 100%;
        height: 100vh;
    }

    .header-nav-overlay__container {
        margin: 0;
        padding: 0;
        position: relative;
        top: 50%;
        transform: translateY(-50%);

        @media @breakpoint__mobile--large {
            top: 50%;
        }
    }

    .header-nav-overlay__list {
        margin: 0 0 40px;
        padding: 0;
        list-style-type: none;

        &:after {
            content: "";
            border-top: 3px solid #e40046;
            display: block;
            height: 5px;
            margin: 25px auto 40px;
            width: 150px;

            @media @breakpoint__mobile--large {
                margin: 15px auto 20px;
            }
        }
    }

    .header-nav-overlay__link {
        color: #003a4a;
        cursor: pointer;
        display: inline-block;
        font-size: 40px;
        letter-spacing: 1.7px;
        margin: 0 auto 20px;
        text-decoration: none;
        transition: 0.3s color;

        @media @breakpoint__mobile--large {
            font-size: 36px;
        }

        @media @breakpoint__mobile--small {
            font-size: 24px;
        }

        &:hover {
  color: #e40046;
  }
  }

  .header-nav-privacypolicy-overlay__link {
  color: #003a4a;
  cursor: pointer;
  display: inline-block;
  font-size: 20px;
  font-family: Flama,Arial,Helvetica,sans-serif;
  font-weight: 100;
  letter-spacing: 0px;
  margin: 0 auto 20px;
  text-decoration: none;
  transition: 0.3s color;

  @media @breakpoint__mobile--large {
  font-size: 36px;
  }

  @media @breakpoint__mobile--small {
  font-size: 24px;
  }

  &:hover {
            color: #e40046;
        }
    }
    
    .header-nav-overlay__logo {
        margin-bottom: 25px;
        width: 370px;

        @media @breakpoint__mobile--large {
            margin-bottom: 5px;
            width: 225px;
        }

        @media @breakpoint__mobile--small {
            width: 175px;
        }
    }

    .header-nav-overlay__social-list {
        list-style-type: none;
        margin: 0 0 45px;
        padding: 0;

        @media @breakpoint__mobile--large {
            margin: 0 0 30px;
        }
    }

    .header-nav-overlay__social-item {
        display: inline-block;
        margin: 0 35px;

        @media @breakpoint__mobile--large {
            margin: 0 25px;
        }

        @media @breakpoint__mobile--small {
            margin: 0 20px;
        }
    }

    .header-nav-overlay__social-link {
        display: block;
    }

    .header-nav-overlay__social-image {
        display: block;

        @media @breakpoint__mobile--small {
            width: 35px;
        }
    }

    .header-nav-overlay__copyright {
        font-size: 14px;

        @media @breakpoint__mobile--small {
            font-size: 12px;
        }
    }
</style>

<script>
    export default {
        name: "home",
        data: function()
        {
            return {
                animationType: "",
                animationDirection : "",
                backgroundColor : "dark",
                baseRouteArray : [],
                currentRoute: "",
                currentRouteCount : 0,
                currentRouteDepth: 0,
                fromName: "",
                hammertime : "",
                modelBeAHunter : [],
                modelExpertise : {},
                modelSpecialties : [],
                modelNews : {},
                modelSeo : {},
                modelWorkFilters : {},
                modelWorkGallery : {},
                logoColor : "light",
                menuColor : "",
                pageTheme: "",
                transitionName: "",
                toName: "",
                templateName : "",
                canScroll: true,
            }
        },
        created: function()
        {
            this.getJson();
        },
        mounted: function()
        {
            for (var i = 0; i < this.$router.options.routes.length; i++)
            {
                if (this.$router.options.routes[i].path.split('/').filter(Boolean).length <= 1)
                {
                    this.baseRouteArray.push(this.$router.options.routes[i].path);
                }
            }

            this.currentRoute = this.$router.history.current.path;
            this.currentRouteCount = this.baseRouteArray.indexOf(this.currentRoute);
            this.currentRouteDepth = this.currentRoute.split('/').filter(Boolean).length;
            this.detectTheme();
            this.initSwipe();
            this.disableSwipe();

            if (this.currentRouteDepth < 2)
            {
                this.addMouseWheelEventListener(this.handleWheel);
                this.addKeyPressListener();
                this.enableSwipe();
            }
        },
        methods:
        {
            getJson: function()
            {
                fetch('/hunter-pr.json', {
                    headers : {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }

                    }).then((response) => response.json())
                    .then((data) => {
                        this.initDataModels(data);
                });
            },
            initDataModels : function(data) {
                this.modelWorkFilters = data.WorkFiltersList;
                this.modelWorkGallery = data.WorkGallery;
                this.modelNews = data.News;
                this.modelSeo = data.SEO;
                this.modelSpecialties = data.Specialties;
                this.modelSolutions = data.Solutions;
                this.modelLeadership = data.Leadership;
                this.modelBeAHunter = data.BeAHunter;
                this.modelOpenings = data.Openings;

                this.updateSeo(this.modelSeo, this.currentRoute);
            },
            initSwipe :function() {
                var app = this.$el;
                var vm = this;
                vm.hammertime = new Hammer(app);
                vm.hammertime.on('swipeleft', function(ev)
                {
                    vm.handleSwipe("left");
                });

               vm.hammertime.on('swiperight', function(ev)
               {
                    vm.handleSwipe("right");
                });
            },
            enableSwipe: function()
            {
                this.hammertime.get('swipe').set({ enable: true });
            },
            disableSwipe: function()
            {
                this.hammertime.get('swipe').set({ enable: false });
            },
            beforeEnterLogo : function(el)
            {
                el.style.opacity = 0;
                el.style.transform = "translateX(-300%)";
            },
            enterLogo : function(el, done)
            {
                TweenMax.to(el, 0.6, {opacity: 1, transform: "translateX(0)", delay: 0.5, ease: Back.easeOut.config(2), onComplete: done});
            },
            beforeEnter : function(el)
            {
                TweenMax.set(".header-nav-button-container", {display:"block"});
                TweenMax.set(".header-nav-button", {className:"-=news-work"});

                if (this.animationType === "1")
                {
                    el.style.position = "absolute";
                    document.body.style.overflowY = "hidden";

                    if (this.animationDirection === "left")
                    {
                        el.style.transform = "translateX(100%)";
                    }
                    else
                    {
                        el.style.transform = "translateX(-100%)";
                    }
                }
                else if (this.animationType === "1-2")
                {
                    this.removeMouseWheelEventListener(this.handleWheel);
                    this.removeKeyPressListener();
                    this.disableSwipe();
                }
                else
                {
                    el.style.opacity = 0;
                }
            },
            enter : function(el, done)
            {
                if (this.animationType === "1")
                {
                    TweenMax.to(el, 0.8, {transform: "translateX(0)", onComplete: done});
                }
                else
                {
                    TweenMax.to(el, 0.4, {opacity: 1, onComplete: done});
                }
            },
            afterEnter : function(el)
            {
                el.style.position = "relative";

                if (el.offsetHeight > window.innerHeight)
                {

                    document.body.style.overflowY = "scroll";
                }
                else
                {
                    document.body.style.overflowY = "hidden";
                }

                if ((this.animationType === "1") || (this.animationType === "2-1"))
                {
                    var vm = this;
                    this.currentRoute = this.$router.history.current.path;
                    this.currentRouteCount = this.baseRouteArray.indexOf(this.currentRoute);

                    setTimeout(function()
                    {
                        vm.addMouseWheelEventListener(vm.handleWheel);
                        vm.addKeyPressListener();
                        vm.enableSwipe();
                    }, 500);
                }
                else
                {
                    document.body.style.overflowY = "scroll";
                }

                this.canScroll = true;
            },
            beforeLeave: function(el)
            {
                this.canScroll = false;

                if (this.animationType === "1")
                {
                    el.style.transform = "translateX(0)";
                    el.style.position = "absolute";
                    el.style.width = "100%";
                }
            },
            leave: function(el, done)
            {
                if (this.animationType === "1")
                {
                    TweenMax.to(el, 0.5, {opacity: 0});

                    if (this.animationDirection === "left")
                    {
                        TweenMax.to(el, 0.8, {transform: "translateX(-100%)", opacity: 0, onComplete: done});
                    }
                    else
                    {
                        TweenMax.to(el, 0.8, {transform: "translateX(100%)", opacity: 0, onComplete: done});
                    }
                }
                else
                {
                    TweenMax.to(el, 0.4, {opacity: 0, onComplete: done});
                }
            },
            addMouseWheelEventListener : function(scrollHandler)
            {
                //console.log("Mouse Add");
                window.addEventListener('wheel', scrollHandler);
            },
            removeMouseWheelEventListener : function(scrollHandler)
            {
                //console.log("Mouse Remove");
                window.removeEventListener('wheel', scrollHandler);
            },
            handleWheel: function(e) {
                if (!this.canScroll) {
                    return;
                }

                let scrollDirection = '';

                if (e.deltaY < 0) {
                    scrollDirection = "up";
                } else if (e.deltaY > 0) {
                    scrollDirection = "down";
                }

                var isBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
                var isTop = ((window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)) <= 0;

                switch (scrollDirection) {
                    case "down":
                        if (isBottom && this.currentRouteCount < (this.baseRouteArray.length - 1)) {
                            this.currentRouteCount++;
                            this.updateRoute();
                        }
                        break;
                    case "up":
                        if (isTop && this.currentRouteCount > 0) {
                            this.currentRouteCount--;
                            this.updateRoute();
                        }
                        break;
                }
            },
            handleSwipe: function(direction) {
                switch (direction) {
                    case "left":
                        if (this.currentRouteCount < (this.baseRouteArray.length - 2)) {
                            this.currentRouteCount++;
                            this.updateRoute();
                        }
                        break;
                    case "right":
                        if (this.currentRouteCount > 0) {
                            this.currentRouteCount--;
                            this.updateRoute();
                        }
                        break;
                }
            },
            updateRoute: function() {
                this.removeMouseWheelEventListener(this.handleWheel);
                this.removeKeyPressListener();
                this.disableSwipe();
                this.$router.push(this.baseRouteArray[this.currentRouteCount]);
            },
            addKeyPressListener: function()
            {
                var vm = this;
                document.addEventListener('keydown', vm.handleKeyPress);
            },
            removeKeyPressListener: function()
            {
                var vm = this;
                document.removeEventListener('keydown', vm.handleKeyPress);
            },
            handleKeyPress: function(e)
            {
                if (e.keyCode === 37)
                {
                    if (this.currentRouteCount > 0)
                    {
                        this.currentRouteCount--;
                        this.removeMouseWheelEventListener(this.handleWheel);
                        this.removeKeyPressListener();
                        this.disableSwipe();
                        this.$router.push(this.baseRouteArray[this.currentRouteCount]);
                    }
                }
                else if(e.keyCode === 39)
                {
                    if (this.currentRouteCount < (this.baseRouteArray.length - 2))
                    {
                        this.currentRouteCount++;
                        this.removeMouseWheelEventListener(this.handleWheel);
                        this.removeKeyPressListener();
                        this.disableSwipe();
                        this.$router.push(this.baseRouteArray[this.currentRouteCount]);
                    }
                }
            },
            detectTheme : function(toDepth)
            {
                switch(this.currentRoute) {
                case "/":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/work":
                    this.backgroundColor = "light";
                    this.logoColor = "light";
                    this.menuColor = "dark";
                    break;
                case "/work/case-studies":
                    this.backgroundColor = "light";
                    this.logoColor = "dark";
                    this.menuColor = "dark";
                    break;
                case "/culture":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/culture/explore":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/culture/about":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/culture/philosophy":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/culture/leadership":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/expertise":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/expertise/explore":
                    this.backgroundColor = "dark";
                    this.logoColor = "dark";
                    this.menuColor = "dark";
                    break;
                case "/expertise/approach":
                    this.backgroundColor = "dark";
                    this.logoColor = "dark";
                    this.menuColor = "dark";
                    break;
                case "/expertise/solutions":
                    this.backgroundColor = "dark";
                    this.logoColor = "dark";
                    this.menuColor = "dark";
                    break;
                case "/expertise/specialties":
                    this.backgroundColor = "dark";
                    this.logoColor = "dark";
                    this.menuColor = "dark";
                    break;
                case "/news":
                    this.backgroundColor = "light";
                    this.logoColor = "light";
                    this.menuColor = "dark";
                    break;
                case "/news/newswire":
                    this.backgroundColor = "light";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case (this.currentRoute.match(/news\/newswire\/[a-z0-9-]+$/) || {}).input:
                    this.backgroundColor = "light";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/contact":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/contact/be-a-hunter":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                case "/privacypolicy":
                    this.backgroundColor = "dark";
                    this.logoColor = "light";
                    this.menuColor = "light";
                    break;
                }
            },
            navBtnClick : function(e)
            {
                if (e.target.classList.contains("active"))
                {
                    var vm = this;
                    if (this.currentRouteDepth < 2)
                    {
                        setTimeout(function()
                        {
                            vm.addMouseWheelEventListener(vm.handleWheel);
                            vm.addKeyPressListener();
                            vm.enableSwipe();
                        }, 500);
                    }

                    this.closeNav();
                }
                else
                {
                    this.openNav();
                }
            },
            openNav : function()
            {
                TweenMax.fromTo(".header-nav-overlay", 0.6, {display: "none", height: 0}, {display: "block", height: "100vh", ease: Power2.easeIn});
                this.removeMouseWheelEventListener(this.handleWheel);
                this.removeKeyPressListener();
                this.disableSwipe();
                document.querySelector(".header-nav-button").classList.add("active");
                document.body.style.overflowY = "hidden";
            },
            closeNav : function()
            {
                document.querySelector(".header-nav-button").classList.remove("active");
                TweenMax.to(".header-nav-overlay", 0.5, {display: "none", height: "0", ease: Power2.easeIn});
                document.body.style.overflowY = "auto";
            },
            navLinkClick: function(url)
            {
                if (this.$router.history.current.path !== url)
                {
                    this.$router.push(url);
                    this.closeNav();
                }
                else
                {
                    var vm = this;
                    if (this.currentRouteDepth < 2)
                    {
                        setTimeout(function()
                        {
                            vm.addMouseWheelEventListener(vm.handleWheel);
                            vm.addKeyPressListener();
                            vm.enableSwipe();
                        }, 500);
                    }

                    this.closeNav();
                }
            }
        },
        watch:
        {
            '$route' (to, from)
            {
                var toDepth = to.path.split('/').filter(Boolean).length;
                var fromDepth = from.path.split('/').filter(Boolean).length;

                this.toName = to.name;
                this.fromName = from.name;

                this.currentRoute = this.$router.history.current.path;
                this.currentRouteDepth = this.currentRoute.split('/').filter(Boolean).length;

                var toCount = this.baseRouteArray.indexOf(to.path);
                var fromCount = this.baseRouteArray.indexOf(from.path);

                if (toCount > fromCount)
                {
                    this.animationDirection = "left";
                }
                else
                {
                    this.animationDirection = "right";
                }

                if ((this.toName === "home") || (this.fromName === "home"))
                {
                    this.animationType = "1";
                    //console.log("Level 1");
                }
                else if (((toDepth === 2) && (fromDepth === 1)) || ((toDepth === 3) && (fromDepth === 1)))
                {
                    this.animationType = "1-2";
                    //console.log("Level 1 to 2");
                }
                else if (((toDepth === 1) && (fromDepth === 2)) || ((toDepth === 1) && (fromDepth === 3)))
                {
                    this.animationType = "2-1";
                    //console.log("Level 2 to 1");
                }
                else if (((toDepth === fromDepth) && (this.currentRouteDepth === 1)) || ((toDepth === 0) && (fromDepth === 1)) || ((toDepth === 1) && (fromDepth === 2)))
                {
                    this.animationType = "1";
                    //console.log("Level 1");
                }
                else if ((toDepth === fromDepth) && ((this.currentRouteDepth === 2) || (this.currentRouteDepth === 3)))
                {
                    this.animationType = "2";
                    //console.log("Level 2");
                }

                TweenMax.set(".header__logo-container", {display: "inline-flex"});

                this.updateSeo(this.modelSeo, to.path);
                this.detectTheme(toDepth);
                this.closeNav();
            }
        },
      currentYear: new Date().getFullYear()
    };
</script>
